import React, { useRef, useEffect, useState } from 'react';
import Icon from '../AppIcon';

const IframePlayer = ({ 
  url, 
  config = {}, 
  onTimeUpdate, 
  onComplete, 
  currentTime, 
  duration,
  className = "w-full h-full"
}) => {
  const iframeRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (url) {
      setIsLoading(false);
    }
  }, [url]);

  if (!url) {
    return (
      <div className={`${className} bg-black flex items-center justify-center`}>
        <div className="text-white text-center">
          <Icon name="AlertCircle" size={48} className="mx-auto mb-4" />
          <p>URL não fornecida</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${className} relative bg-black`}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black">
          <div className="flex flex-col items-center space-y-4 text-white">
            <div className="animate-spin">
              <Icon name="Loader2" size={40} />
            </div>
            <p>Carregando conteúdo...</p>
          </div>
        </div>
      )}

      <iframe
        ref={iframeRef}
        src={url}
        className="w-full h-full"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
};

export default IframePlayer;
